import * as Comlink from 'comlink';
import type { GitApi } from './git.worker';
import GitWorker from './git.worker?worker';

let remote: Comlink.Remote<GitApi> | null = null;

/** The git worker (created on first use). */
export function gitWorker(): Comlink.Remote<GitApi> {
  remote ??= Comlink.wrap<GitApi>(new GitWorker({ name: 'git' }));
  return remote;
}
